"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.S3ItemReference = void 0;
const typebox_1 = require("@sinclair/typebox");
/**
 * @deprecated use S3ItemReference from common instead
 */
exports.S3ItemReference = typebox_1.Type.Object({
    bucket: typebox_1.Type.String(),
    key: typebox_1.Type.String(),
    region: typebox_1.Type.String(),
    type: typebox_1.Type.Optional(typebox_1.Type.String()),
});
//# sourceMappingURL=s3-item-reference.js.map